import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  {
    q: "Il medico viene fisicamente a casa?",
    a: "No. A casa arriva un infermiere qualificato con TytoCare. Il medico si collega in diretta e guida la visita da remoto.",
  },
  {
    q: "È una semplice videochiamata?",
    a: "No. È una visita assistita: l’infermiere utilizza strumenti diagnostici connessi e il medico valuta i dati in tempo reale.",
  },
  {
    q: "Quali specialisti sono disponibili?",
    a: "Medici generalisti, pediatri, geriatri e internisti, otorini, pneumologi, dermatologi e cardiologi.",
  },
  {
    q: "Serve scaricare un’app?",
    a: "No. Non è necessaria alcuna app: la richiesta avviene direttamente tramite WhatsApp.",
  },
  {
    q: "In quanto tempo arriva l’infermiere?",
    a: "Dipende dalla zona e dalla fascia oraria. Ti comunichiamo la prima disponibilità utile prima della conferma.",
  },
  {
    q: "Quanto costa?",
    a: "Il prezzo parte da €129 e varia in base a specialità, zona, orario e strumenti richiesti. Viene sempre comunicato prima della conferma.",
  },
  {
    q: "È un servizio per emergenze?",
    a: "No. È dedicato a condizioni non emergenziali. In caso di emergenza contatta il 112/118.",
  },
  {
    q: "Posso richiederlo per un genitore anziano?",
    a: "Sì. Puoi organizzare la visita per un familiare e restare aggiornato a distanza.",
  },
  {
    q: "È disponibile nelle RSA?",
    a: "Sì. Organizziamo missioni specialistiche nelle strutture, con visite per più residenti nella stessa giornata.",
  },
  {
    q: "Il TytoCare rimane nella struttura?",
    a: "No. L’infermiere porta il kit mobile e lo utilizza anche per le missioni successive in altre strutture.",
  },
];

export default function FAQSection() {
  return (
    <section id="faq" className="bg-white pt-20 pb-28 sm:py-28" data-testid="faq-section">
      <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <span className="inline-flex items-center gap-2 rounded-full bg-[#F6F4FA] px-4 py-2 text-xs font-bold uppercase tracking-[0.18em] text-[#5B2C91]">
            <span className="h-2 w-2 rounded-full bg-[#D4F84A]" />
            Domande frequenti
          </span>
          <motion.h2
            initial={{ opacity: 0, y: 22 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
            className="font-heading mt-5 text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight text-[#1F152E]"
            data-testid="faq-title"
          >
            Le risposte più cercate
          </motion.h2>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="mt-10"
        >
          <Accordion type="single" collapsible className="w-full">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="border-b border-[#5B2C91]/10"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger className="py-5 text-base font-semibold text-[#1F152E] hover:no-underline hover:text-[#5B2C91]">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-[15px] leading-relaxed text-[#4A4059]">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
}
